export const ProductStatusCssClasses = ['', 'info', 'default'];
export const ProductStatusTitles = ['', 'Идэвхтэй', 'Идэвхгүй'];
export const ProductIsPublishCssClasses = ['info', 'danger'];
export const ProductIsPublishTitles = ['Зарна', 'Зарахгүй'];
export const ProductTypeCssClasses = ['', 'success', 'info', 'danger', 'dark'];
export const ProductTypeTitles = [
  '',
  'Purchase',
  'Gift With Purchase',
  'Bundle',
  'Sampler',
];
export const productStatusList = [
  { code: -1, name: 'Төлөв' },
  { code: 1, name: 'Идэвхтэй' },
  { code: 0, name: 'Идэвхгүй' },
];
export const productIsPublishList = [
  { code: -1, name: 'Зарах эсэх' },
  { code: 1, name: 'Зарна' },
  { code: 0, name: 'Зарахгүй' },
];

export const productTypeList = [
  { code: '', name: 'Төрөл' },
  { code: 'P', name: 'Purchase' },
  { code: 'G', name: 'Gift With Purchase' },
  { code: 'B', name: 'Bundle' },
  { code: 'S', name: 'Sampler / For Gift' },
];

export const defaultSorted = [{ dataField: 'a.product_code', order: 'desc' }];
export const sizePerPageList = [
  { text: '10', value: 10 },
  { text: '20', value: 20 },
  { text: '50', value: 50 },
  { text: '100', value: 100 },
];
export const initialFilter = {
  filter: {
    searchText: '',
    websiteCode: '',
    categoryCode: '',
    typeCode: '',
    brandCode: '',
    status: -1,
  },
  sortOrder: 'desc', // asc||desc
  sortField: 'a.created_at',
  pageNumber: 1,
  pageSize: 10,
};

export const initialEditorContent = {
  entityMap: {},
  blocks: [
    {
      key: '637gr',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
};

export const initialProduct = {
  icon: '',
  images: [],
  details: '',
  productCode: '',
  categoryCode: '',
  typeCode: '',
  brandCode: '',
  name: '',
  shortName: '',
  color: '',
  sizeType: 1,
  sizeLetter: '',
  sizeValue: '',
  websites: '',
  tags: '',
  websiteList: [],
  tagList: [],
  margin: '0.00',
  price: '0.00',
  salePrice: '0.00',
  count: 0,
  reserveCount: 0,
  withGift: 0,
  isPublish: 0,
  status: 1,
  useColor: 0,
  useSize: 0,
  cost: '0.00',
  weight: '0.00',
  bundleCount: 0,
  orderedCount: 0,
  saleOrderedCount: 0,
  subProductCount: 0,
};
